import { render, staticRenderFns } from "./Internation.vue?vue&type=template&id=5cf6e63b&scoped=true&"
import script from "./Internation.vue?vue&type=script&lang=js&"
export * from "./Internation.vue?vue&type=script&lang=js&"
import style0 from "./Internation.vue?vue&type=style&index=0&id=5cf6e63b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6e63b",
  null
  
)

export default component.exports